import { FC } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { Input } from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
};

/**
 * 顧客環境URLのフォームのベースです。
 * NOTE: Chakra の Text は非制御コンポーネントなので、react-hook-form の register でフォーム化しています。
 */
export const PoseidonUrlFormBase: FC<Props> = ({ register }) => (
  <Input
    id="poseidonUrl"
    type="text"
    {...register('poseidonUrl', {
      maxLength: {
        value: 200,
        message: '顧客環境URLは 200 文字以内にする必要があります。',
      },
    })}
  />
);
